(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('.faq__item, .pdp-faq details, .ec-questions details').forEach(item => {
    const summary = item.querySelector(':scope > summary');
    if (!summary) return;
    const body = document.createElement('div');
    body.className = 'faq-motion__body';
    [...item.childNodes].filter(node => node !== summary).forEach(node => body.append(node));
    item.append(body);
    item.classList.add('has-faq-motion');
    let animation = null;
    let reveal = null;
    let targetOpen = item.open;
    const sync = () => {
      item.dataset.accordionOpen = String(targetOpen);
      summary.setAttribute('aria-expanded', String(targetOpen));
    };
    const finish = () => {
      item.open = targetOpen;
      animation?.cancel();
      reveal?.cancel();
      animation = reveal = null;
      item.style.removeProperty('height');
      item.style.removeProperty('overflow');
      sync();
    };
    summary.addEventListener('click', event => {
      event.preventDefault();
      const start = item.getBoundingClientRect().height;
      const opacity = getComputedStyle(body).opacity;
      const transform = getComputedStyle(body).transform;
      targetOpen = animation ? !targetOpen : !item.open;
      animation?.cancel();
      reveal?.cancel();
      sync();
      if (reduced.matches) { finish(); return; }
      item.style.removeProperty('height');
      const wasOpen = item.open;
      item.open = true;
      const style = getComputedStyle(item);
      const closedHeight = summary.getBoundingClientRect().height + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
      const end = targetOpen ? item.getBoundingClientRect().height : closedHeight;
      item.style.overflow = 'hidden';
      const options = {duration: targetOpen ? 480 : 340, easing: targetOpen ? 'cubic-bezier(.22,1,.36,1)' : 'cubic-bezier(.32,.72,0,1)', fill: 'both'};
      animation = item.animate([{height: `${start}px`}, {height: `${end}px`}], options);
      reveal = body.animate([
        {opacity: wasOpen ? opacity : 0, transform: wasOpen ? transform : 'translateY(-7px)'},
        {opacity: targetOpen ? 1 : 0, transform: targetOpen ? 'translateY(0)' : 'translateY(-5px)'}
      ], options);
      animation.onfinish = finish;
    });
    item.addEventListener('toggle', () => {if (!animation) {targetOpen = item.open;sync();}});
    reduced.addEventListener('change', () => {if (animation) finish();});
    window.addEventListener('resize', () => {if (animation) finish();}, {passive: true});
    sync();
  });
})();

// #ingredients などで質問へ飛んだとき、その質問を開く
(() => {
  const openTarget = () => {
    if (!location.hash) return;
    let el = null;
    try { el = document.querySelector(decodeURIComponent(location.hash)); } catch (_) { return; }
    const details = el && (el.tagName === 'DETAILS' ? el : el.closest('details'));
    if (details) details.open = true;
  };
  window.addEventListener('hashchange', openTarget);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href$="#ingredients"]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.pathname === location.pathname) {
      const target = document.getElementById('ingredients');
      if (target && target.tagName === 'DETAILS') target.open = true;
    }
  });
  openTarget();
})();

